export const Video: React.FC<React.ComponentProps<'video'>> = (props) => {
  return <video {...props} />;
};
